/*
 * Persönliches Profil: freiwillige Angaben für Zusammenarbeit (Firma, Funktion, Kontakt).
 * Sichtbar nur für Personen, mit denen man ein Board oder Team teilt – und nur, wenn freigegeben.
 */
export interface UserProfile {
  company: string;
  department: string;
  jobTitle: string;
  phone: string;
  mobile: string;
  location: string;
  website: string;
  about: string;
  /** Angaben für Personen sichtbar, mit denen ich ein Board oder Team teile */
  visible: boolean;
}

export const EMPTY_PROFILE: UserProfile = { company: '', department: '', jobTitle: '', phone: '', mobile: '', location: '', website: '', about: '', visible: true };

export const PROFILE_FIELDS: { key: Exclude<keyof UserProfile, 'visible'>; label: string; max: number; type?: 'tel' | 'url' | 'textarea'; placeholder?: string; autoComplete?: string }[] = [
  { key: 'jobTitle', label: 'Funktion / Tätigkeit', max: 100, placeholder: 'z. B. Projektleitung', autoComplete: 'organization-title' },
  { key: 'company', label: 'Firma / Organisation', max: 100, autoComplete: 'organization' },
  { key: 'department', label: 'Abteilung / Bereich', max: 100 },
  { key: 'location', label: 'Standort', max: 100, placeholder: 'z. B. Stuttgart, Büro 2.14' },
  { key: 'phone', label: 'Telefon', max: 40, type: 'tel', autoComplete: 'tel' },
  { key: 'mobile', label: 'Mobil', max: 40, type: 'tel', autoComplete: 'tel' },
  { key: 'website', label: 'Website', max: 200, type: 'url', placeholder: 'https://…', autoComplete: 'url' },
  { key: 'about', label: 'Über mich', max: 500, type: 'textarea', placeholder: 'Wofür bin ich ansprechbar? Erreichbarkeit, Arbeitszeiten …' },
];

/** Kurzzeile unter dem Namen: „Funktion · Firma“ – nur bei freigegebenem Profil */
export function profileHeadline(p: Partial<UserProfile> | null | undefined): string {
  if (!p || p.visible === false) return '';
  return [p.jobTitle, p.company].map((x) => (x ?? '').trim()).filter(Boolean).join(' · ');
}

/** Profil einer anderen Person (nur für Personen mit gemeinsamem Board oder Team) */
export interface PersonInfo {
  id: string;
  name: string;
  image: string | null;
  /** leer bei Gästen und für Gäste */
  email: string;
  guest: boolean;
  profile: Omit<UserProfile, 'visible'> | null;
}

/** Nur eigene, vom Server erzeugte Profilbilder anzeigen (nie beliebige URLs) */
export const AVATAR_URL = /^\/api\/avatars\/[A-Za-z0-9_-]{1,64}\/[a-z0-9]{6,32}$/;
export const avatarSrc = (image: string | null | undefined, size: 64 | 256): string | null => (image && AVATAR_URL.test(image) ? `${image}?s=${size}` : null);
